export const NOTIFICATION_EVENTS = '/admin/app/notification-events';
export const NOTIFICATION_TEMPLATES = '/admin/app/notification-templates';
export const NOTIFICATION_EVENT_SETTINGS = 'admin/notification-events/settings/';
//Dashboard
export const DEFAULT_INFO = 'default-info';
export const DEFAULT_ACADEMIC_INFO = 'default-academic-info';
export const DEFAULT_DASHBOARD_INFO = 'default-dashboard-info';
export const AVAILABLE_COURSE_LIST = 'available-course-list';
export const STUDENT_OVERVIEW = 'student-overview';
export const SCHOOL_OVERVIEW = 'school-overview';
export const INSTRUCTOR_STUDENT_OVERVIEW = 'instructor-student-overview';
export const AUDIENCE_OVERVIEW_CHART = 'audience-overview-chart';
export const BROWSER_OVERVIEW_CHART = 'browser-overview-chart';
export const BUSINESS_OVERVIEW = 'business-overview';
export const CONTACT_OVERVIEW = 'contact-overview';
export const TEAM_OVERVIEW = 'team-overview';
export const DOCTORS_LIST = 'doctors-list';
export const UPCOMING_APPOINTMENTS = 'upcoming-appointments';
export const DEFAULT_HOSPITAL_INFO = 'default-hospital-info';
export const HOSPITAL_ACTIVITIES = 'hospital-activities';
export const PATIENT_STATISTICS = 'patient-statistics';
export const HRM_BASIC_DATA = 'hrm-basic-data';
export const PROJECT_OVERVIEW = 'project-overview';
export const YEARLY_HOLIDAY = 'yearly-holiday';
export const EMPLOYEE_OVERVIEW = 'employee-overview';

//Sample pages
export const REPORTS = 'reports';
export const CALENDARS = 'calendars';
export const STAGES = 'stages';
export const TASKS = 'tasks';

//Profile
export const MY_PROFILE = '/my-profile';
export const All_NOTIFICATION = '/all-notifications';
export const LOGOUT = '/admin/log-out';

//app setting view
export const APP_SETTINGS = '/app-setting';
export const GENERAL_SETTINGS = 'general-settings';

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = '/get-re-captcha-setting';
//Sms settings
export const GET_SMS_SETTINGS_INFO = 'get-sms-setting-info';
//Email settings
export const GET_EMAIL_SETTINGS = '/admin/app/settings/delivery-settings';

//DataTable
export const DATATABLE_DATA = 'crud';
export const DATATABLE_SEARCH_SELECT = '/datatable/name';
export const BET_DATATABLE_DATA = 'bet-data';
export const BET_DATATABLE_SEARCH = 'bet-data/search';

export const BETFAIR_DATATABLE_DATA = 'betfair-data';
export const BETFAIR_DATATABLE_SEARCH = 'betfair-data/search';
export const BETFAIR_DATATABLE_LOG = 'betfair-log';
export const BETFAIR_DATATABLE_LOG_SEARCH = 'betfair-log/search';

export const BETFAIR_GAME = 'betfair/game';
export const BETFAIR_GAME_DATA = 'betfair/game/data';

export const BET_DATATABLE_HISTORY_DATA = 'data-history';
export const BET_DATATABLE_HISTORY_SEARCH = 'data-history/search';

export const GAME_FAVOURITE = 'game-favourite';
export const GAME_NOTIFICATION = 'game-notification';
export const GAME_NOTIFICATION_ADD = 'game-notification/add';
export const GAME_NOTIFICATION_DELETE = 'game-notification/delete';

export const MANAGE_NOTIFICATION_ALL = 'manage-notifications/all';
export const MANAGE_NOTIFICATION_ADD = 'manage-notifications/add';
export const MANAGE_NOTIFICATION_EDIT = 'manage-notifications/edit';
export const MANAGE_NOTIFICATION_DELETE = 'manage-notifications/delete';

export const TEAMS_LIST = 'teams';
export const LEAGUES_LIST = 'leagues';

export const COMBOS_ADD = '/combo/add-game';
export const COMBOS_ADD_CUSTOM = '/combo/add-custom-game';
export const OPEN_COMBOS_LIST = '/combo/open-list';
export const GENERATED_COMBOS_LIST = '/combo/generated-list';
export const COMBOS_SAVE = '/combo/save';
export const COMBOS_GENERATE = '/combo/generate';
export const COMBOS_DELETE = '/combo/delete';
export const COMBOS_DELETE_GAME = '/combo/delete-game';
export const COMBOS_SAVE_RESULT = '/combo/save-result';
export const COMBOS_GENERATED_SAVE = '/combo/save-generated';
export const COMBOS_GENERATED_DELETE_SINGLE = '/combo/delete-generated-combo';
export const COMBOS_GENERATED_SAVE_ITEM = '/combo/save-generated-item';
export const COMBOS_GENERATED_DELETE_ITEM = '/combo/delete-generated-item';

export const GAME_VIEW = '/game';
export const TEAM_VIEW = '/team';
export const LEAGUE_VIEW = '/league';

export const LOAD_ODDS_HISTORY = '/odds/history';
export const LOAD_ODDS_HISTORY_TABLE = '/odds/table';

//roles and users
export const ROLES = 'admin/auth/roles';
export const USERS = 'admin/auth/users';
export const USERS_LIST = 'user-list';
export const ALL_USERS = 'all-users';
export const GET_USERS = 'get/users';
export const GET_STATUSES = 'admin/app/statuses';
export const INVITE_USER = '/admin/auth/users/invite-user';
export const ADD_USER = '/admin/auth/users/add-user';
export const DETACH_ROLES = 'admin/auth/users/detach-roles/';
export const UPDATE_USER_NAME = '/update-user-name/';

//Notification
export const NOTIFICATIONS_LIST = '/notifications/list';
export const NOTIFICATIONS = '/admin/user/notifications';
export const AUTHENTICATE_USER = '/admin/authenticate-user';
export const LOGIN_USER = '/login-user';

// Language
export const LANGUAGE = 'languages';
export const BASIC_SETTINGS = '/get-basic-setting-data';

// Social links
export const CHANGE_SOCIAL_LINKS = '/change-social-link';

//Payment Methods
export const PAYMENT_METHOD = '/payment-method';
export const GET_PAYMENT_METHOD_STATUS = '/payment-method-status';
export const GET_STRIPE_STATUS = '/stripe-status';
export const GET_PAYPAL_STATUS = '/paypal-status';